
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/campaign/[slug]",
      function () {
        return require("private-next-pages/campaign/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/campaign/[slug]"])
      });
    }
  